import cn from '@ui/utils/cn'

export const sDefaultTemplate = cn(
  'flex flex-row flex-wrap items-start justify-center gap-8 px-8 pb-8'
)
